import styled from 'styled-components'

export const SelectTestWrapper = styled.div`
  width: 100%;
`
